import React from 'react';
import PropTypes from 'prop-types';
import { FONT_SIZE_CLASS } from './Styles';

export const ErrorMessageDisplay = (props) => {
    if (!props.errorMessage) return null;

    const fontSizeClass = FONT_SIZE_CLASS[props.size] || FONT_SIZE_CLASS.md;
    const style = `py-1 pl-1 my-2 text-center text-red-700 bg-red-200 ${fontSizeClass}`;

    return <div className={style}>{props.errorMessage}</div>;
};

ErrorMessageDisplay.propTypes = {
    errorMessage: PropTypes.string,
    size: PropTypes.string,
};
